import planet from './planet/planet'

planet()